/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    function jsonHtmlDecoder(key, value) {
        if (typeof value === 'string' && value.indexOf('\u0874/') !== -1) {
            return value.replace(/\u0874/g, '<').replace(/\u0873/g, '>');
        }
        return value;
    }
    var basePath = '/static/local/ext-highchart';
    var highchartEls = document.querySelectorAll('[data-init="highchart"]');
    if (highchartEls.length) {
        moya.loader.js(basePath + '/highcharts.bundle.js').then(function () {
            document.body.dispatchEvent(new CustomEvent('highchartLoaded'));
            return moya.lang === 'is' ?
                moya.loader.js(basePath + '/iceland.lang.js') :
                moya.loader.js(basePath + '/english.lang.js');
        })
            .then(function () {
            highchartEls.forEach(function (el) {
                var dataEl = el.querySelector('.moya-highchart-data');
                var chartEl = el.querySelector('.moya-highchart-container');
                var customOptionEl = el.querySelector('.moya-highchart-custom');
                if (!dataEl) {
                    return;
                }
                var options = JSON.parse(dataEl.textContent, jsonHtmlDecoder);
                if (!options) {
                    return;
                }
                if (customOptionEl) {
                    var customOptions = new Function('return ' + customOptionEl.textContent)();
                    options = Highcharts.merge(true, options, customOptions);
                }
                var chart = new Highcharts.Chart(chartEl, options);
                var initEvent = new CustomEvent("highchartInit", {
                    detail: {
                        chart: chart,
                        el: chartEl,
                    }
                });
                document.body.dispatchEvent(initEvent);
            });
        }).catch(function (error) {
            console.error(error);
        });
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
